import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { getAppList } from "@/api/app"; //  此处请自行替换地址
import infoList from "@/mixins/infoList";
import { mapMutations, mapGetters } from "vuex";
export default {
  name: "roleAppsList",
  mixins: [infoList],
  props: ["type"],
  data: function data() {
    return {
      listApi: getAppList,
      appList: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("app", ["selectAppId", "isChangeAppInfo"])), {}, {
    test: {
      get: function get() {
        return this.selectAppId;
      },
      set: function set(appId) {
        if (appId != 0) {
          this.setSelectAppId(appId);
        }
      }
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations("app", ["setSelectAppId", "setIsChangeAppInfo"])), {}, {
    //初始化渠道下拉菜单
    init: function init() {
      var _this = this;
      this.listApi({
        app_type: this.type
      }).then(function (response) {
        _this.appList = response.data.list;
      });
    }
  }),
  created: function created() {
    this.init();
  },
  watch: {
    //监听是否发生渠道信息更改事件，重载渠道下拉菜单
    isChangeAppInfo: function isChangeAppInfo(_isChangeAppInfo) {
      if (_isChangeAppInfo == 1) {
        this.init();
        this.setIsChangeAppInfo(0);
      }
    }
  }
};